import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";

// Import your API adapter functions
import {
  addInternationalStatics,
  fetchInternationalStatics,
  //   editInternationalStatics,
  updateInternationalStatics,
  trashInternationalStatics,
} from "../../Adapters/ApiAdapter";
import { baseImage_path } from "../../variables/Variables";
import { toast, ToastContainer } from "react-toastify";

const InternationalStatics = () => {
  const [facilityCards, setFacilityCards] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    img_icon: null,
    existing_icon: "",
  });
  const [editId, setEditId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    fetchFacilityCards();
  }, []);

  const fetchFacilityCards = async () => {
    try {
      const res = await fetchInternationalStatics();
      setFacilityCards(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch facility cards", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async () => {
    const payload = new FormData();
    payload.append("title", formData.title);
    payload.append("content", formData.content);
    if (formData.img_icon) payload.append("img_icon", formData.img_icon);

    try {
      let response;
      if (isEditMode) {
        response = await updateInternationalStatics(editId, payload);
      } else {
        response = await addInternationalStatics(payload);
      }
      if (response && response.status === "true") {
        toast.success(
          isEditMode ? "Item updated successfully" : "Item added successfully"
        );
        fetchFacilityCards();
        handleClose();
      } else {
        toast.error("Failed to submit item");
      }
    } catch (err) {
      console.error("Error submitting data", err);
    }
  };

  const handleEdit = (item) => {
    setFormData({
      title: item.title,
      content: item.content,
      img_icon: null,
      existing_icon: item.img_icon,
    });

    setEditId(item.id);
    setIsEditMode(true);
    setOpenDialog(true);
  };

  const handleTrash = async (id) => {
    try {
      const response = await trashInternationalStatics(id);
      if (response && response.status === "true") {
        toast.success("Item deleted successfully");
        fetchFacilityCards();
      } else {
        toast.error("Failed to delete item");
      }
    } catch (err) {
      console.error("Error deleting item", err);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setFormData({
      title: "",
      content: "",
      img_icon: null,
      existing_icon: null,
    });
    setEditId(null);
    setIsEditMode(false);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "title", headerName: "Title", flex: 1 },
    { field: "content", headerName: "Content", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            size="small"
            color="error"
            sx={{ ml: 1 }}
            onClick={() => handleTrash(params.row.id)}
          >
            Trash
          </Button>
        </Box>
        // <>
        //   <IconButton color="primary" onClick={() => handleEdit(params.row)}>
        //     <Edit />
        //   </IconButton>
        //   <IconButton color="error" onClick={() => handleTrash(params.row.id)}>
        //     <Delete />
        //   </IconButton>
        // </>
      ),
    },
  ];

  return (
    <Box p={3}>
      <ToastContainer />
      <Typography variant="h5" gutterBottom>
        Facility Card Top Section CMS
      </Typography>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => setOpenDialog(true)}
      >
        Add Facility Card
      </Button>
      <Box mt={2} style={{ height: 400 }}>
        <DataGrid
          rows={facilityCards}
          columns={columns}
          getRowId={(row) => row.id}
          autoHeight
          //   pageSize={5}
        />
      </Box>

      <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{isEditMode ? "Edit" : "Add"} Facility Card</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="Title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Content"
            name="content"
            value={formData.content}
            onChange={handleInputChange}
          />
          {(formData.img_icon || formData.existing_icon) && (
            <Box mt={2}>
              <Typography variant="subtitle2">Icon Preview:</Typography>
              <img
                src={
                  formData.img_icon
                    ? URL.createObjectURL(formData.img_icon)
                    : `${baseImage_path}/${formData.existing_icon}`
                }
                alt="Icon Preview"
                style={{ width: 100, height: 100, objectFit: "cover" }}
              />
            </Box>
          )}

          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Icon
            <input
              type="file"
              hidden
              name="img_icon"
              onChange={handleInputChange}
            />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            style={{ fontWeight: "bold", backgroundColor: "grey" }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            {isEditMode ? "Save" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default InternationalStatics;
